export default __webpack_public_path__ + "static/media/gift001.c00d9b1b.png";